class MThinIconsBanner extends HTMLElement {
  constructor() {
    super();
    this.initialized = false;
  }

  connectedCallback() {
    if (this.isConnected && !this.initialized) {
      this.init();
      this.initialized = true;
    }
  }

  disconnectedCallback() {
    this.detachListeners();
    this.initialized = false;
  }

  init() {
    this.cacheElements();
    this.initIconPopups();
  }

  reinit() {
    this.detachListeners();
    this.init();
  }

  cacheElements() {
    this.iconButtons = this.querySelectorAll('.MThinIconsBanner__Icon');
  }

  initIconPopups() {
    this.iconButtons.forEach(button => {
      button.addEventListener('click', this.openPopup);
    });
  }

  openPopup(e) {
    const popupContents = e.currentTarget.querySelector(
      '[data-popup-info-template]'
    );
    GlobalNPopup.openWithContents('generic', popupContents.innerHTML);
  }

  detachListeners() {
    this.iconButtons.forEach(button => {
      button.removeEventListener('click', this.openPopup);
    });
  }
}
customElements.define('m-thin-icons-banner', MThinIconsBanner);
